{
  "eyebrow": "Bevestig je abonnement",
  "title": "Bekijk en configureer.",
  "sub": "Je kan facturatiecyclus of abonnement binnen je productlijn op elk moment aanpassen in je beheerdersdashboard. Overschakelen tussen Time en Project regelen we samen met jou.",
  "yourPlan": "Jouw abonnement",
  "changePlan": "Wijzig abonnement",
  "billing": "Facturatiecyclus",
  "billingMonthLabel": "Maandelijks betalen",
  "billingMonthDesc": "Flexibel. Stop wanneer je wil.",
  "billingYearLabel": "Jaarlijks betalen",
  "billingYearDesc": "15% korting. Eén keer per jaar gefactureerd.",
  "addons": "Add-ons",
  "addon": {
    "ssec": "Sociale zekerheid (check-in/out@work)",
    "ssecDesc": "Alleen België — automatische Dimona-aangifte.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live GPS voor bedrijfsvoertuigen. +€4,80 / voertuig / maand.",
    "vehicles": "Voertuigen"
  },
  "users": {
    "title": "Hoeveel gebruikers heb je nodig?",
    "help": "Iedereen die Done-it gebruikt, telt als één gebruiker, inclusief beheerders en medewerkers.",
    "active": "gebruikers"
  },
  "estimate": "Geschatte maandkost",
  "estimateNote": "Exclusief btw. U betaalt voor het aantal gebruikers dat u hier instelt; u kunt dit later aanpassen.",
  "estimateUnavailable": "Prijscatalogus niet beschikbaar. Probeer opnieuw om de laatste prijzen te laden."
}
